import { render } from "./Laborales.vue?vue&type=template&id=5912e584&scoped=true"
import script from "./Laborales.vue?vue&type=script&lang=js"
export * from "./Laborales.vue?vue&type=script&lang=js"

import "./Laborales.vue?vue&type=style&index=0&id=5912e584&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5912e584"]])

export default __exports__